(function () {
  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function looksLikeFaqTitle(text) {
    var t = clean(text).toLowerCase();
    if (!t) return false;
    if (t.indexOf('frequently asked questions') !== -1) return true;
    return /(^|[^a-z])faqs?([^a-z]|$)/.test(t);
  }

  // FAQ block starts at the first H2 whose text contains
  // "FAQ", "FAQs", or "frequently asked questions".
  function isFaqHeading(el) {
    return el && el.tagName === 'H2' && looksLikeFaqTitle(el.textContent);
  }

  // Each question is an H3. The following <p> tags are the answer.
  function isQuestion(el) {
    return el && el.tagName === 'H3';
  }

  function isBreak(el) {
    if (!el) return false;
    if (el.tagName === 'HR') return true;
    return el.tagName === 'H2';
  }

  function makeItem(questionEl) {
    var details = document.createElement('details');
    details.className = 'article-faq__item';

    var summary = document.createElement('summary');
    summary.className = 'article-faq__question';

    questionEl.classList.add('article-faq__heading');
    summary.appendChild(questionEl);

    var icon = document.createElement('span');
    icon.className = 'article-faq__icon';
    icon.setAttribute('aria-hidden', 'true');
    summary.appendChild(icon);

    var answer = document.createElement('div');
    answer.className = 'article-faq__answer';

    details.appendChild(summary);
    details.appendChild(answer);

    return { details: details, answer: answer };
  }

  function init() {
    var root = document.querySelector('.article-content .content');
    if (!root || root.dataset.articleFaqReady) return;
    root.dataset.articleFaqReady = 'true';

    var heading = null;
    for (var i = 0; i < root.children.length; i++) {
      if (isFaqHeading(root.children[i])) {
        heading = root.children[i];
        break;
      }
    }
    if (!heading) return;

    var list = document.createElement('div');
    list.className = 'article-faq';

    var el = heading.nextElementSibling;
    while (el && !isBreak(el)) {
      if (!isQuestion(el)) {
        el = el.nextElementSibling;
        continue;
      }

      var next = el.nextElementSibling;
      var item = makeItem(el);

      while (next && next.tagName === 'P' && !isBreak(next)) {
        var after = next.nextElementSibling;
        item.answer.appendChild(next);
        next = after;
      }

      list.appendChild(item.details);
      el = next;
    }

    if (list.childElementCount) heading.after(list);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
